module.exports = __webpack_public_path__ + "png/balance3.png?4d8db0646c282c703bf38f015679368b";